<template>
    <div class="div"></div>
</template>

<style lang="scss" scoped>
.div {
    background-color: rgba(0, 0, 0, 0.12);
    cursor: wait;
    height: 1em;
    margin-bottom: 0.25rem;
    border-radius: 0.25rem;
}
</style>
